import { render } from "./FormUpload.vue?vue&type=template&id=208ef828&scoped=true"
import script from "./FormUpload.vue?vue&type=script&lang=ts"
export * from "./FormUpload.vue?vue&type=script&lang=ts"

import "./FormUpload.vue?vue&type=style&index=0&id=208ef828&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-208ef828"

export default script